(() => {
  if (customElements.get('logistics-notice')) return;

  class LogisticsNotice extends HTMLElement {
    connectedCallback() {
      const configEl = this.querySelector('[data-logi-config]');
      if (!configEl) return;

      try {
        const config = JSON.parse(configEl.textContent);
        this.byId = {};
        (config.variants || []).forEach((v) => {
          this.byId[v.id] = v.state;
        });
      } catch (e) {
        return;
      }

      this._onVariantChange = this._onVariantChange.bind(this);
      document.addEventListener('variant:change', this._onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    _onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      const state = this.byId[variant.id];
      // Variante absente du mapping (ex: quick-buy d'un autre produit) -> on ignore
      if (state == null) return;

      // Rupture : carte TOUJOURS visible (la ligne livraison reste). Parcours selon le réglage.
      if (state === 'sold_out') {
        this.setAttribute('data-state', this.dataset.keepParcours === '1' ? 'stock' : 'soldout');
        return;
      }

      // preorder -> timeline préco ; in_stock / low / low_count -> timeline stock
      this.setAttribute('data-state', state === 'preorder' ? 'preorder' : 'stock');
    }
  }

  customElements.define('logistics-notice', LogisticsNotice);
})();
